import React, { Suspense } from "react";
import { Image } from "mui-image";
import LottieAnimation from "../../components/LottieAnimation";
import { Button, CircularProgress } from "@mui/material";
import OtherContent from "./OtherContent";
import CENTREHEROLEFT from '../../assets/images/centre-hero-left.svg';
import CENTREHERORIGHT from '../../assets/images/centre-hero-right.svg';
import { ReactComponent as ARROW } from "../../assets/images/arrow-right.svg";

const MainContent = ({ setRequestDrawer = () => { } }) => {
  return (
    <div className="home-wrapper expert-wrapper centre-wrapper">
      <div className="home-main expert-main" style={{borderBottom: "1px solid #dfdfdf"}}>
       <div className="home-main-one" style={{textAlign: 'center'}}>
        <h1>
        Verified business account for <br/>Fitness <span className="underline">Centres</span>
        </h1>
        <Button
          onClick={() => setRequestDrawer(true)}
          id="step-1-home-main-button"
          className="home-main-button"
          variant="contained"
          size="large"
        >
          Request access
          <ARROW className="home-main-btn-icon" />
        </Button>
        <div className="animation-div-center" style={{ margin: "40px auto 0 auto"}}>
        <Suspense
            fallback={
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  padding: "3rem",
                }}
              >
                <CircularProgress size="3rem" />
              </div>
            }
          >
            <LottieAnimation path="/lotties/centre-hero.json" />
          </Suspense>
        </div>
        <div className="animation-div-left">
        <Suspense
            fallback={
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  padding: "3rem",
                }}
              >
                <CircularProgress size="3rem" />
              </div>
            }
          >
            {/* <LottieAnimation path="/lotties/expert-hero-left.json" /> */}
            <Image
                      height="100%"
                      width="100%"
                      fit="contain"
                      src={CENTREHEROLEFT}
                      duration={800}
                      alt=""
                      showLoading={true}
                      className="icon-image"
                    />
          </Suspense>
        </div>
        <div className="animation-div-right">
        <Suspense
            fallback={
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  padding: "3rem",
                }}
              >
                <CircularProgress size="3rem" />
              </div>
            }
          >
            {/* <LottieAnimation path="/lotties/expert-hero-right.json"/> */}
            <Image
                      height="100%"
                      width="100%"
                      fit="contain"
                      src={CENTREHERORIGHT}
                      duration={800}
                      alt=""
                      showLoading={true}
                      className="icon-image"
                    />
          </Suspense>
        </div>
       </div>
      </div>
      <Suspense
        fallback={
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              padding: "3rem",
            }}
          >
            <CircularProgress size="3rem" />
          </div>
        }
      >
        <OtherContent setRequestDrawer={setRequestDrawer} />
      </Suspense>
    </div>
  )
}

export default MainContent